import { all, fork, put, takeEvery, call } from "redux-saga/effects";

import {
    getStalls,
    getStallById,
    createStall,
    updateStall,
    deleteStall,
} from "helpers/api/stalls";

import { StallActionTypes } from "./constants";
import {
    stallApiResponseSuccess,
    stallApiResponseError,
} from "./actions";

function* getStallsFn({ payload }: any): any {
    try {
        const response = yield call(
            getStalls,
            payload?.vendorId
        );

        yield put(
            stallApiResponseSuccess(
                StallActionTypes.GET_STALLS,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.GET_STALLS,
                error
            )
        );
    }
}

function* getStallByIdFn({ payload }: any): any {
    try {
        const response = yield call(getStallById, payload);
        yield put(
            stallApiResponseSuccess(
                StallActionTypes.GET_STALL_BY_ID,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.GET_STALL_BY_ID,
                error
            )
        );
    }
}

function* addStallFn({ payload }: any): any {
    try {
        const response = yield call(createStall, payload);
        yield put(
            stallApiResponseSuccess(
                StallActionTypes.ADD_STALL,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.ADD_STALL,
                error
            )
        );
    }
}

function* updateStallFn({ payload }: any): any {
    try {
        const { id, originalVendorId, ...body } = payload;

        const response = yield call(
            updateStall,
            id,
            originalVendorId,
            body
        );

        yield put(
            stallApiResponseSuccess(
                StallActionTypes.UPDATE_STALL,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.UPDATE_STALL,
                error
            )
        );
    }
}

function* deleteStallFn({ payload }: any): any {
    try {
        const response = yield call(
            deleteStall,
            payload.vendorId,
            payload.stallId
        );
        yield put(
            stallApiResponseSuccess(
                StallActionTypes.DELETE_STALL,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.DELETE_STALL,
                error
            )
        );
    }
}

function* bulkImportStallsFn({ payload: { stalls } }: any): any {
    try {
        const total = stalls.length;
        const errors: string[] = [];
        
        for (let i = 0; i < total; i++) {
            try {
                yield call(createStall, stalls[i]);
                yield put({
                    type: StallActionTypes.API_RESPONSE_SUCCESS,
                    payload: { actionType: '@@stall/BULK_IMPORT_PROGRESS', progress: Math.round(((i + 1) / total) * 100) }
                });
            } catch (err: any) {
                errors.push(`Row ${i + 1}: ${err?.response?.data?.message || err.message || 'Failed'}`);
            }
        }
        
        if (errors.length === total) {
            yield put(stallApiResponseError(StallActionTypes.BULK_IMPORT_STALLS, errors.join('; ')));
        } else {
            yield put(stallApiResponseSuccess(StallActionTypes.BULK_IMPORT_STALLS, {}));
            if (errors.length > 0) {
                yield put(stallApiResponseError(StallActionTypes.BULK_IMPORT_STALLS, errors.join('; ')));
            }
        }
    } catch (error: any) {
        yield put(stallApiResponseError(StallActionTypes.BULK_IMPORT_STALLS, error?.message || 'Failed to import'));
    }
}

export function* watchGetStalls() {
    yield takeEvery(StallActionTypes.GET_STALLS, getStallsFn);
}

export function* watchGetStallById() {
    yield takeEvery(StallActionTypes.GET_STALL_BY_ID, getStallByIdFn);
}

export function* watchAddStall() {
    yield takeEvery(StallActionTypes.ADD_STALL, addStallFn);
}

export function* watchUpdateStall() {
    yield takeEvery(StallActionTypes.UPDATE_STALL, updateStallFn);
}

export function* watchDeleteStall() {
    yield takeEvery(StallActionTypes.DELETE_STALL, deleteStallFn);
}

export function* watchBulkImportStalls() {
    yield takeEvery(StallActionTypes.BULK_IMPORT_STALLS, bulkImportStallsFn);
}

function* stallSaga() {
    yield all([
        fork(watchGetStalls),
        fork(watchGetStallById),
        fork(watchAddStall),
        fork(watchUpdateStall),
        fork(watchDeleteStall),
        fork(watchBulkImportStalls),
    ]);
}

export default stallSaga;